import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-project-activity-type',
  templateUrl: './project-activity-type.component.html',
  styleUrls: ['./project-activity-type.component.css']
})
export class ProjectActivityTypeComponent implements OnInit {
    projectActivityTypeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.projectActivityTypeKeyno = this.stateService.getStateParams()['projectactivitytype_keyno'];
    }

    private async loadEdit() {
        if (!!this.projectActivityTypeKeyno) {
            this.edit = (await this.datatask.Post(2185, { projectactivitytype_keyno: this.projectActivityTypeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2186, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    projectactivitytype_keyno: string;
    project_keyno: string;
    project_name: string;
    activitytype_name: string;
    activitytype_prefix: string;
    lastnumber: string;
}
